import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, Star, ChevronLeft, ChevronRight } from "lucide-react";

const REVIEWS = [
  {
    quote:
      "Golden Decor turned our wedding into a fairytale. The floral mandap left every single guest speechless — it was exactly the dream we described, only more magical.",
    name: "Reema & Aakash",
    event: "Wedding · Mangaluru",
  },
  {
    quote:
      "From planning to the last light being switched off, the team handled everything. We actually got to enjoy our own reception without worrying about a thing.",
    name: "Sowmya D'Souza",
    event: "Reception & Coordination",
  },
  {
    quote:
      "The stage lighting and entertainment were on another level. The chauffeured car entry made my sister feel like royalty. Worth every rupee.",
    name: "Nikhil Shetty",
    event: "Sangeet & Luxury Cars",
  },
  {
    quote:
      "Elegant, punctual and genuinely creative. Their concept board matched our theme perfectly and the decor photographed beautifully. Highly recommended in Mangaluru.",
    name: "Farida & Imran",
    event: "Engagement Decor",
  },
];

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const prev = () => setI((v) => (v - 1 + REVIEWS.length) % REVIEWS.length);
  const next = () => setI((v) => (v + 1) % REVIEWS.length);
  const r = REVIEWS[i];

  return (
    <section id="reviews" className="relative bg-[#F3F1EC] py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-[1500px] px-6 sm:px-12 lg:px-16">
        <div className="mb-14 grid grid-cols-1 items-end gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="mb-6 flex items-center gap-4">
              <span className="h-px w-14 bg-[#C5A059]" />
              <span className="font-body text-xs font-semibold uppercase tracking-[0.3em] text-[#A37E3A]">
                Kind Words
              </span>
            </div>
            <h2 className="font-heading text-4xl font-light leading-[1.05] tracking-tight text-[#1A1918] sm:text-5xl lg:text-6xl">
              Loved by the couples we&apos;ve <span className="italic text-gradient-gold">celebrated</span> with.
            </h2>
          </div>
          <div className="flex items-center gap-1 lg:col-span-4 lg:justify-end">
            {[...Array(5)].map((_, s) => (
              <Star key={s} size={20} className="fill-[#C5A059] text-[#C5A059]" />
            ))}
            <span className="ml-3 font-body text-sm text-[#5C5A56]">5.0 · Real celebrations</span>
          </div>
        </div>

        <div className="relative overflow-hidden rounded-[28px] border border-[#E6E2D6] bg-[#FCFBF8] p-8 shadow-[0_20px_60px_rgba(0,0,0,0.05)] sm:p-14 lg:p-20">
          <Quote className="mb-8 h-12 w-12 text-[#C5A059]" strokeWidth={1.2} />
          <div className="min-h-[220px] sm:min-h-[200px] lg:min-h-[180px]">
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={i}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -24 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`review-${i}`}
              >
                <p className="font-heading text-2xl font-light leading-snug text-[#1A1918] sm:text-3xl lg:text-4xl">
                  {r.quote}
                </p>
                <footer className="mt-8 flex items-center gap-4">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#1A1918] font-heading text-lg text-[#EAD39C]">
                    {r.name.charAt(0)}
                  </span>
                  <span className="flex flex-col">
                    <span className="font-body text-sm font-semibold text-[#1A1918]">{r.name}</span>
                    <span className="font-body text-xs uppercase tracking-[0.2em] text-[#A37E3A]">
                      {r.event}
                    </span>
                  </span>
                </footer>
              </motion.blockquote>
            </AnimatePresence>
          </div>

          <div className="mt-10 flex items-center justify-between">
            <div className="flex items-center gap-2">
              {REVIEWS.map((_, d) => (
                <button
                  key={d}
                  onClick={() => setI(d)}
                  data-testid={`review-dot-${d}`}
                  aria-label={`Go to review ${d + 1}`}
                  className={`h-2 rounded-full transition-all duration-300 ${
                    d === i ? "w-8 bg-[#C5A059]" : "w-2 bg-[#D8D3C6] hover:bg-[#C5A059]/60"
                  }`}
                />
              ))}
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={prev}
                data-testid="review-prev"
                aria-label="Previous review"
                className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-[#E6E2D6] text-[#1A1918] transition-colors duration-300 hover:border-[#C5A059] hover:text-[#A37E3A]"
              >
                <ChevronLeft size={18} />
              </button>
              <button
                onClick={next}
                data-testid="review-next"
                aria-label="Next review"
                className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#1A1918] text-[#FCFBF8] transition-colors duration-300 hover:bg-[#C5A059] hover:text-[#0D0C0A]"
              >
                <ChevronRight size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
